import { useEffect, useState } from "react";

import { useScrollLock } from "../../hooks/useScrollLock";

import {
  ModalOverlay,
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  ModalText,
  ModelNameInput,
  InputLabel,
  Row,
} from "./TrainModal.styles";

import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import Button from "../utils/Button/Button";
import { useNavigate } from "react-router-dom";

const TrainModal = ({ isOpen, onClose, onContinue, loading = false }) => {
  const [modelName, setModelName] = useState("");
  const [shouldRender, setShouldRender] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const navigate = useNavigate();

  useScrollLock(shouldRender);

  useEffect(() => {
    if (!isOpen) {
      setModelName("");
    }
  }, [isOpen]);

  useEffect(() => {
    const randomId = Math.floor(1000 + Math.random() * 9000);
    setModelName(`New Model #${randomId}`);
  }, [shouldRender]);

  // Kontrola renderovanja i animacije
  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      setIsAnimating(false); // Početno stanje bez animacije
      // Kratka pauza da se modal renderuje pre animacije
      const timer = requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsAnimating(true);
        });
      });
      return () => cancelAnimationFrame(timer);
    } else if (shouldRender) {
      setIsAnimating(false);
      // Čeka da se animacija završi pre uklanjanja iz DOM-a
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300); // 300ms koliko traje animacija

      return () => clearTimeout(timer);
    }
  }, [isOpen, shouldRender]);

  if (!shouldRender) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleTutorialClick = () => {
    navigate("/train-tutorial");
    onClose();
  };

  const handleContinue = () => {
    if (modelName.trim() && !loading) {
      onContinue(modelName.trim());
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick} $isAnimating={isAnimating}>
      <ModalContainer $isAnimating={isAnimating}>
        <ModalContent>
          <Row>
            <ModalTitle>Train a new model</ModalTitle>
            <CloseButton onClick={onClose}>
              <CloseSvg />
            </CloseButton>
          </Row>
          <ModalText>
            Upload video clips to train your own model. After training is
            complete, you will have your own model (template) for generating new
            videos.
          </ModalText>

          <ModalText>
            Your model is only accessible to you by default. After our review
            and approval, it will have the opportunity to be included in
            publicly available templates and earn you 2 credits with each
            generation.
          </ModalText>

          <ModalText>
            Enjoy 40% off your first try - create your own custom model today!
          </ModalText>

          <ModalText onClick={handleTutorialClick} $click>
            📚 View our training tutorial to get started
          </ModalText>

          <InputLabel>Name</InputLabel>
          <ModelNameInput
            type="text"
            placeholder="Enter model name..."
            value={modelName}
            onChange={(e) => setModelName(e.target.value)}
            maxLength={50}
          />

          <Button
            onClick={handleContinue}
            disabled={!modelName.trim() || loading}
            loading={loading}
            title={"Continue"}
            style={{ width: 180, alignSelf: "center" }}
          />
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default TrainModal;
